import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMessages = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 17 17",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "#4D4540",
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", { d: "m11.753 5.396-5.328 2.64-.944-1.905L10.81 3.49a1.064 1.064 0 0 1 .943 1.906ZM11.753 11.566l-5.328-2.64-.944 1.906 5.329 2.64a1.064 1.064 0 0 0 .943-1.905Z" }), /* @__PURE__ */ _jsx("path", { d: "M17 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM17 13.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM7 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h17v17H0z"
		})
	}) })]
});
export default SvgIconMessages;
